import type { ConsentDoc } from '@/shared/data-types';
import { present } from '@/shared/overlay';
import { ConsentModal } from './consent-modal';

/**
 * 약관 원문 모달을 앱 루트 슬롯에 명령형 mount — 고객센터 약관 행·마케팅 '내용 보기'가 이 함수만 호출.
 * `openConsentDoc`(코드로 지목) 과 같은 오버레이·같은 본문이되 조회 없이 받은 문서를 바로 얹는다. entity 레벨이라 feature·
 * page 어디서나 호출 가능(widget 은 feature 에서 금지). `key` 로 같은 약관 중복 mount 방지(연타 스택 회피).
 */
export function openConsent(consent: ConsentDoc): void {
  present(
    ({ open, close }) => (
      <ConsentModal consent={consent} open={open} onOpenChange={(next) => !next && close()} />
    ),
    { key: `consent:${consent.consentId}` },
  );
}
